/* Trackting — barra annunci: su mobile mette gli annunci in fila (uno accanto all'altro)
   e li fa scorrere in marquee continuo SOLO se non entrano nella larghezza. Con un solo
   annuncio (o se entrano tutti) restano fermi e centrati. Su desktop NON tocca nulla:
   il carousel Debutify (autoplay/scroll-snap) resta invariato.
   Loop senza buco: si clona una volta il set di annunci e si trasla di ESATTAMENTE la
   larghezza di un set (px), cosi' la copia prende il posto dell'originale. */
(function () {
  'use strict';
  var MQ = '(max-width: 749px)';
  var SPEED = 54;     // px/s (velocita' di scorrimento; +20% rispetto a 45; regolabile)
  var THRESHOLD = 8;  // px di overflow oltre cui far scorrere

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function parts(comp) {
    var slider = comp.querySelector('[id^="Slider-"]');
    var track = comp.querySelector('.dbtfy-abm-track');
    if (!slider || !track) return null;
    return { comp: comp, slider: slider, track: track };
  }

  // solo gli annunci (slide), NON eventuali <script>/<style> che alcuni blocchi
  // (es. il countdown) rendono come fratelli dentro il track: vanno esclusi da
  // misura e clonazione.
  function originals(track) {
    return Array.prototype.filter.call(track.children, function (n) {
      return n.classList &&
             n.classList.contains('slideshow__slide') &&
             !n.hasAttribute('data-abm-clone');
    });
  }

  function measureSet(track) {
    var w = 0;
    originals(track).forEach(function (n) {
      var cs = window.getComputedStyle(n);
      w += n.getBoundingClientRect().width +
           (parseFloat(cs.marginLeft) || 0) +
           (parseFloat(cs.marginRight) || 0);
    });
    return w;
  }

  function removeClones(track) {
    each(track.querySelectorAll('[data-abm-clone]'), function (n) { n.remove(); });
  }

  function addClones(track) {
    originals(track).forEach(function (node) {
      var c = node.cloneNode(true);
      c.setAttribute('data-abm-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      track.appendChild(c);
    });
  }

  function restart(track) {
    track.style.animation = 'none';
    void track.offsetWidth; // reflow: riparte da capo
    track.style.animation = '';
  }

  // --- Neutralizzazione dell'engine slider Debutify (solo su mobile, solo questa istanza) ---
  function stopEngine(comp) {
    if (typeof comp.play === 'function' && !comp._abmPlayShadow) {
      comp._abmPlayShadow = true;
      comp.play = function () {}; // shadow del metodo di prototype: nessun autoplay
    }
    comp.autoPlay = false;
    if (comp.autoplay) { clearInterval(comp.autoplay); }
    comp._abmTouched = true;
  }

  function restoreEngine(comp) {
    if (!comp._abmTouched) return;
    if (comp._abmPlayShadow) {
      delete comp.play; // ripristina il metodo di prototype
      comp._abmPlayShadow = false;
    }
    comp.autoPlay = (comp.dataset.autoplay === 'true');
    comp._abmTouched = false;
    if (typeof comp.reinit === 'function') { comp.reinit(); } // ricalcola pagine e riparte
    else if (comp.autoPlay && typeof comp.play === 'function') { comp.play(); }
  }

  function toStatic(p) {
    if (p.slider.classList.contains('is-abm-marquee') ||
        p.track.querySelector('[data-abm-clone]')) {
      p.slider.classList.remove('is-abm-marquee');
      p.track.style.removeProperty('--abm-shift');
      p.track.style.removeProperty('--abm-duration');
      p.track.style.animation = '';
      removeClones(p.track);
    }
    p.track._abmSetW = 0;
  }

  function toDesktop(p) {
    p.slider.classList.remove('is-abm-row');
    toStatic(p);
    restoreEngine(p.comp);
  }

  function applyOne(comp, isMobile) {
    var p = parts(comp);
    if (!p) return;

    if (!isMobile) { toDesktop(p); return; }

    // ---- MOBILE ----
    stopEngine(p.comp);

    var slides = originals(p.track); // solo .slideshow__slide non-clone

    if (slides.length < 1) {
      p.slider.classList.remove('is-abm-row');
      toStatic(p);
      return;
    }

    // 1+ annunci: riga affiancata. Centrata se entra, marquee (ticker) se non entra.
    // Vale anche per il countdown da solo che eccede: lo scorre il ticker, non piu'
    // il vecchio marquee interno del countdown (rimosso).
    p.slider.classList.add('is-abm-row');

    var setW = measureSet(p.track);
    var avail = p.slider.clientWidth;
    if (!setW || !avail) return; // non ancora misurabile

    if ((setW - avail) > THRESHOLD) {
      var alreadyMarquee = p.slider.classList.contains('is-abm-marquee') &&
                           !!p.track.querySelector('[data-abm-clone]');
      var prev = p.track._abmSetW || 0;
      // (ri)avvia solo se serve: entrata in marquee, o cambio larghezza rilevante
      // (es. cifre del countdown popolate dopo). Evita scatti a ogni tick.
      if (!alreadyMarquee || Math.abs(setW - prev) > 12) {
        removeClones(p.track);
        addClones(p.track);
        p.track._abmSetW = setW;
        p.track.style.setProperty('--abm-shift', '-' + Math.round(setW) + 'px');
        p.track.style.setProperty('--abm-duration', Math.max(6, Math.round(setW / SPEED)) + 's');
        p.slider.classList.add('is-abm-marquee');
        restart(p.track);
      }
    } else {
      toStatic(p); // entra tutto: riga ferma centrata
    }
  }

  function apply() {
    var isMobile = window.matchMedia(MQ).matches;
    each(document.querySelectorAll('dbtfy-slider-component.announcement-bar'), function (comp) {
      applyOne(comp, isMobile);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);

  var rt;
  function schedule() { clearTimeout(rt); rt = setTimeout(apply, 200); }
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  // le cifre del countdown si popolano dopo il primo render: rimisura alcune volte
  var n = 0;
  var iv = setInterval(function () { apply(); if (++n >= 6) clearInterval(iv); }, 1500);
})();
